<input
  [fluid]="true"
  [formControl]="control"
  pInputText
  placeholder="Wprowadź wartość"
  step="1"
  type="number" />
